// extracted by mini-css-extract-plugin
module.exports = {"category-breadcrumbs-container":"BreadcrumbCategory_category-breadcrumbs-container__Sk8ET"};